/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sendresetlink2Inputs */

const zh_auth_sendresetlink2 = /** @type {(inputs: Auth_Sendresetlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送重置链接`)
};

const en_auth_sendresetlink2 = /** @type {(inputs: Auth_Sendresetlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send reset link`)
};

const es_auth_sendresetlink2 = /** @type {(inputs: Auth_Sendresetlink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar enlace de restablecimiento`)
};

/**
* | output |
* | --- |
* | "Send reset link" |
*
* @param {Auth_Sendresetlink2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_sendresetlink2 = /** @type {((inputs?: Auth_Sendresetlink2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sendresetlink2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_sendresetlink2(inputs)
	if (locale === "en") return en_auth_sendresetlink2(inputs)
	return es_auth_sendresetlink2(inputs)
});
export { auth_sendresetlink2 as "auth_sendResetLink" }